import { Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { MembersignserviceService } from '@app/services/signs/membersignservice.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { MemberofficeService } from '@app/services/memberoffices/memberoffice.service';
import { MemberService } from '@app/services/member.service';
import { MatDialog } from '@angular/material/dialog';
import { SnackbarService } from '@app/services/shared/snackbar.service';
import { AuthService } from '@app/services/auth/auth.service';
import { DatePipe } from '@angular/common';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import { MembershipService } from '@app/services/membership.service';
import { ConfirmationService } from 'primeng/api';

interface Sign {
  memberId: number;
  institutionId: number;
  signId: number;
  action: string;
  date: Date;
  newInstitutionId: number;
}

@Component({
  selector: 'app-signs',
  templateUrl: './signs.component.html',
  styleUrls: ['./signs.component.css']
})


export class SignsComponent implements OnInit, OnDestroy, OnChanges {
  @Input() roleid;
  @Input() baseinfo: any;
  @Input() id;
  membersigns;
  edit = false;
  editmembersign;
  memberid;
  viewAddSign = false;
  seelectedrole;
  editform;
  

  institutionaccess;
  tecken: Sign[];
  minmaxyear = { minYear: '1920', maxYear: '2099' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public mask = [/[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/]; // zipcode
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  mobiledevice: false;
  subscriptions: Subscription[] = [];
  can_edit_member_signs = false;
  memberships;

  constructor(
    private activatedRoute: ActivatedRoute,
    private membershipService: MembershipService,
    private membersignsService: MembersignserviceService,
    private permissionsService: PermissionsService,
    private datePipe: DatePipe,
    private authService: AuthService,
    private memberService: MemberService,
    private router: Router,
    private fb: FormBuilder,
    private memberOfficeService: MemberofficeService,
    private snackbarService: SnackbarService,
    public dialog: MatDialog,
    private confirmationService: ConfirmationService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (this.memberid) {
      this.getMemberSigns(this.memberid);
    }
    if (changes) {
      this.permissionsService.setInstitutionAccess();
      this.permissionsService.institutionaccess.subscribe(a => {
        if (a) {
          this.institutionaccess = a;
        }
      });
    }
    if (changes.roleid) {
      this.roleid = Number(changes.roleid.currentValue);
    }
  }

  getMemberships(memberid) {
    this.subscriptions.push(this.membershipService.getMembershipByMemberId(memberid).subscribe(memberships => {
      if (memberships) {
        this.memberships = memberships;
      }
    }));
  }

  ngOnInit() {
    this.permissionsService.selectedrole.subscribe(r => {
      if(r) {
      
        this.setPermissions();
      }
    })
   
    this.editform = this.fb.group({
      id: ['', ''],
      institutionId: ['', ''],
      institutionShortName: ['', ''],
      institutionName: ['', ''],
      date: ['', ''],
      signId: ['', ''],
      signName: ['', '']
    });
    this.authService.isMobileDevice.subscribe(mobile => {
      this.mobiledevice = mobile;
    });

    this.memberService.timestamp.subscribe(_ => {
      if (this.memberid && this.roleid) {
        this.getMemberSigns(this.memberid);
      }
    });
    this.activatedRoute.paramMap.subscribe(paramMap => {
      this.memberid = +paramMap.get('id');
       
      this.getMemberships(this.memberid);
      this.viewAddSign = false;
      this.edit = false;
      this.getMemberSigns(this.memberid);
    });
  }

  setPermissions() {
 
   /* this.permissionsService.hasPermissionForMember('EDIT_MEMBER_SIGNS', this.memberid).subscribe(resp => {
      console.log('RESP: ', resp);
      if(resp) {
        this.can_edit_member_signs = resp;
       
      }
    });*/
    const user_permissions = JSON.parse(sessionStorage.getItem('selectedrole')).permissions;
    this.can_edit_member_signs = user_permissions.indexOf('EDIT_MEMBER_SIGNS') !== -1;
  }

  getMemberSigns(memberid: number) {
    this.subscriptions.push(this.membersignsService.GetSignsByMemberIdAsync(this.roleid, memberid).subscribe(data => {
      if (data) {
        this.membersigns = data;
       // this.setPermissions();
      }
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  editSign(sign: any) {
    sign.date = this.datePipe.transform(sign.date, 'yyyy-MM-dd');
    this.editmembersign = sign;
    this.editform.patchValue(this.editmembersign);
    this.edit = true;
  }

  addSign() {
    
    if (this.institutionaccess.admininstitutionid) {
      this.router.navigate(['grader'], { queryParams: { institutionid: this.institutionaccess.admininstitutionid, memberid: this.memberid, type: 'member' }, queryParamsHandling: "merge" });
    } else {
     
      this.router.navigate(['grader'], { queryParams: { memberid: this.memberid, type: 'member' }, queryParamsHandling: "merge" });
    }
  }

  confirmRemoveSign(sign: any) {
     this.confirmationService.confirm({
      header: 'Bekräfta radering',
      message: 'Vill du radera vald utmärkelse?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
        this.removeSign(sign);
      },
      reject: () => {
      }
    });
  }

  removeSign(sign: any) {
    const signdata = [{
      memberId: this.memberid,
      institutionId: sign.institutionId,
      signId: sign.signId,
      action: 'delete'
    }];
    this.subscriptions.push(this.memberOfficeService.UpdateMemberSign(signdata).subscribe(response => {
      if (response) {
        if (response[0].rowsAffected !== 0) {
          this.getMemberSigns(this.memberid);
          this.snackbarService.openSnackBar('Utmärkelsen borttagen', null);
        }
      }
    }));
  }

  saveSign(sign: any) {
    const preparedSign: Sign = {
      memberId: this.memberid,
      institutionId: this.editmembersign.institutionId,
      signId: sign.signId,
      action: 'update',
      date: new Date(this.editform.get('date').value),
      newInstitutionId: sign.institutionId,
    };
    const _sign: Sign[] = [];
    _sign.push(preparedSign);
    this.tecken = _sign;

    this.subscriptions.push(this.memberOfficeService.UpdateMemberSign(_sign).subscribe(response => {
      if (response) {
        this.getMemberSigns(this.memberid);
        if (response[0].rowsAffected !== 0) {
          this.snackbarService.openSnackBar('Uppdatering sparad.', null);
        }
      }
    }));
    this.edit = false;
  }

  cancelSign() {
    this.edit = false;
  }

  signAdded(event) {
    if (event === 'signAdded') {
      this.getMemberSigns(this.memberid);
    } else if (event === 'cancelAddSign') {
    }
    this.viewAddSign = false;
  }
}
